// Generated by CoffeeScript 2.7.0
var CheckBoxMixin;

export default CheckBoxMixin = {
  data: function() {
    return {
      otherOption: this.field.generateOtherOptionProxy()
    };
  },
  computed: {
    valuePresent: function() {
      return Boolean(this.value.length);
    }
  },
  methods: {
    validateOtherOption: function() {
      var is_selected;
      is_selected = _.any(this.value, (option) => {
        return option === this.otherOption;
      });
      if (is_selected && !this.otherOption.value) {
        return this._addError('其他选项不能为空');
      }
    },
    validateOptionsLimit: function() {
      var ref, ref1, ref2, ref3;
      if (!this.value.length) {
        return;
      }
      if (!(((ref = this.field.settings) != null ? (ref1 = ref.length_limit) != null ? ref1.max : void 0 : void 0) || ((ref2 = this.field.settings) != null ? (ref3 = ref2.length_limit) != null ? ref3.min : void 0 : void 0))) {
        return;
      }
      if (this.value.length < this.field.settings.length_limit.min) {
        return this._addError(`您至少需要选择 ${this.field.settings.length_limit.min} 个选项`);
      } else if (this.value.length > this.field.settings.length_limit.max) {
        return this._addError(`您最多只能选择 ${this.field.settings.length_limit.max} 个选项`);
      }
    },
    _parseValueToEntries: function() {
      var _result, delete_old_entries, field_id, i, len, old_entries, old_entry, old_entry_index, option, ref;
      field_id = this.field.id;
      old_entries = this.entries.slice();
      _result = [];
      ref = this.value;
      for (i = 0, len = ref.length; i < len; i++) {
        option = ref[i];
        old_entry_index = _.findIndex(old_entries, function(entry) {
          var ref1;
          if (option.id) {
            return ((ref1 = entry.option_id) != null ? ref1.toString() : void 0) === option.id.toString();
          } else {
            return !entry.option_id;
          }
        });
        // add new option
        if (old_entry_index === -1) {
          _result.push({
            option_id: option.id,
            value: option.value,
            field_id: field_id
          });
        } else {
          old_entry = _.clone(old_entries.splice(old_entry_index, 1)[0]);
          // update other option value
          old_entry._destroy = false;
          if (!old_entry.option_id) {
            old_entry.value = option.value;
          }
          _result.push(old_entry);
        }
      }
      // deleted options
      delete_old_entries = [];
      _.each(old_entries, function(entry) {
        if (entry.id) {
          old_entry = _.clone(entry);
          old_entry._destroy = true;
          return delete_old_entries.push(old_entry);
        }
      });
      return _result = _result.concat(delete_old_entries);
    },
    _validate: function() {
      this.validatePresence();
      this.validateOtherOption();
      return this.validateOptionsLimit();
    },
    _parseEntriesToValue: function(entries) {
      return this.value = _.chain(entries).map((entry) => {
        var option;
        // 普通选项
        option = entry.option_id ? _.find(this.field.options, function(item) {
          return item.id === entry.option_id;
        }) : this.field.hasOtherOption ? _.tap(this.otherOption, function(obj) {
          return obj.value = entry.value;
        }) : void 0;
        if (option && !entry.id) {
          // 如果是缓存的选中项，则应该参与计数，来自于服务器选中的则无需参与计数
          option.incrementCounter();
        }
        return option;
      }).compact().value();
    }
  }
};
